import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-guest-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './guest-layout.html',
  styleUrl: './guest-layout.scss'
})
export class GuestLayout implements OnInit{
  ngOnInit(): void {  }
}
